import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ViewService } from '../../../../../shared/store/view/views.service';
import { filter, Observable } from 'rxjs';
import { View } from '../../../../../shared/store/view/types';
import { Filter } from '../../../../../shared/store/search/types';
import { SearchService } from '../../../../../shared/store/search/search.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { Router } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-sales-person-dashboard-subheader',
  standalone: false,
  templateUrl: './sales-person-dashboard-subheader.component.html',
  styleUrl: './sales-person-dashboard-subheader.component.scss',
})
export class SalesPersonDashboardSubheaderComponent
  implements OnInit, OnDestroy
{
  view$: Observable<View>;

  constructor(
    private readonly viewService: ViewService,
    private readonly searchService: SearchService,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly router: Router,
  ) {
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x),
      )
      .subscribe((view) => {
        //Set builtInFilterGroups from view
        const builtinActiveFilterGroups =
          view.searchView.builtInFilterGroups.filter((filterGroup) =>
            filterGroup.filters.some((filter) =>
              filter.domains.some((domain) => domain.isActive),
            ),
          );
        for (const filterGroup of builtinActiveFilterGroups) {
          for (const filter of filterGroup.filters) {
            if (filter.domains.some((domain) => domain.isActive)) {
              this.searchService.addDefaultActiveFilter(filter, false);
            }
          }
        }

        //Set permanentFilters from view
        const permanentActiveFilters = view.searchView.permanentFilters?.filter(
          (filter) => filter.domains.some((domain) => domain.isActive),
        );

        if (permanentActiveFilters) {
          for (const filter of permanentActiveFilters) {
            this.searchService.addDefaultActiveFilter(filter, false);
          }
          //deactive if there is smartFilter
          this.searchService.temporaryDeactivatePermanentFilters();
        }

        //Set propertyFilters from view
        const propertyActiveFilters = view.searchView.propertyFilters?.filter(
          (filter) =>
            filter.items.some((item) =>
              item.domains.some((domain) => domain.isActive),
            ),
        );

        if (propertyActiveFilters) {
          for (const propertyActiveFilter of propertyActiveFilters) {
            for (const item of propertyActiveFilter.items) {
              if (!item.domains.some((domain) => domain.isActive)) continue;

              const filter: Filter = {
                description: '',
                domains: item.domains,
                isReadOnly: propertyActiveFilter.isReadOnly,
                name: propertyActiveFilter.propertyId + '/' + item.label,
                tag: propertyActiveFilter.tag,
                text: item.label,
              };

              this.searchService.addDefaultActiveFilter(filter, false);
            }
          }
        }
        this.searchService.temporaryActivateTempActiveFilters(this.router.url);

        this.breadcrumbService.set('@dashboardTitle', view.title);
      });
  }

  ngOnDestroy(): void {
    this.breadcrumbService.set('@dashboardTitle', '');
  }
}
